import _cloneDeep from 'lodash/cloneDeep'

import {
  GET_AVAILABLEDEPARTMENTS_SUCCESS,
  GET_AVAILABLEDEPARTMENTS_REQUESTED,
  GET_WORKSESSION_REQUESTED,
  GET_WORKSESSION_SUCCESS,
  DASHBOARD_FAILED,
  DASHBOARD_RESET
} from '../actions/actionTypes'
import { authActions } from '../../actions/auth'
import { authService } from '../../services/auth-service'

const initialState = {
  department: {},
  cashboxes: [],
  loading: false,
  commonError: false,
  isOpen: !authActions.checkWorkSession()
}

const dashboardReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_AVAILABLEDEPARTMENTS_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
        isOpen: !authActions.checkWorkSession()
      }
    case GET_AVAILABLEDEPARTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        cashboxes: [...action.payload]
      }
    case GET_WORKSESSION_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
      }
    case GET_WORKSESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        isOpen: false,
        department: authService.getActiveCashBoxId()
      }
    case DASHBOARD_FAILED:
      return {
        ...state,
        loading: false,
        commonError: action.payload
      }
    case DASHBOARD_RESET:
      return _cloneDeep(initialState)

    default:
      return state
  }
}

export default dashboardReducer